import { DialogForm, Form, useDialogExitWarning } from '@ais-ui/ui-core';
import React, { useState, useCallback } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useLocalization } from '@ais-ui/locale-management';
import { useGetShareGroups } from '@ais-ui/websockets';
import { SendMessageForm } from './SendMessageForm';
import { SendMessageFormValues } from './sendMessageForm';

interface SendMessageDialogProps {
  form: UseFormReturn<SendMessageFormValues>;
  onSubmit: (data: SendMessageFormValues) => void;
  isSubmitting: boolean;
  setShowOuterDialog: (showOuterDialog: boolean) => void;
}

export const SendMessageDialog = ({
  form,
  onSubmit,
  isSubmitting,
  setShowOuterDialog,
}: SendMessageDialogProps) => {
  const { messages } = useLocalization();
  const [showDialog] = useState<boolean>(true);
  const { data: groups, isLoading: isLoadingGroups } = useGetShareGroups();

  const handleConfirm = useCallback(() => {
    setShowOuterDialog(false);
  }, [setShowOuterDialog]);

  const { handleClose, ExitWarningDialog } = useDialogExitWarning({
    onConfirm: handleConfirm,
    isDirty: form.formState.isDirty,
    title: messages.messageWarningTitle || 'Discard message?',
    description:
      messages.messageWarningDescription ||
      'Your message will be lost. Are you sure you want to close?',
  });

  return (
    <Form {...form}>
      <DialogForm
        showDialog={showDialog}
        onOpenChange={setShowOuterDialog}
        size="md"
        onClose={handleClose}
      >
        <DialogForm.Header>
          <DialogForm.Title>Send message</DialogForm.Title>
        </DialogForm.Header>
        <DialogForm.Body
          isLoading={isLoadingGroups}
          hasLoaded={!isLoadingGroups && !!groups}
          observeResize={false}
        >
          <SendMessageForm form={form}></SendMessageForm>
        </DialogForm.Body>
        <DialogForm.Footer>
          <DialogForm.Cancel>{messages.genericCancel}</DialogForm.Cancel>
          <DialogForm.Submit
            id="submit-send-message-button"
            disabled={isSubmitting}
            onSubmit={form.handleSubmit(onSubmit)}
          >
            {isSubmitting ? messages.genericSubmitting : messages.genericSubmit}
          </DialogForm.Submit>
        </DialogForm.Footer>
      </DialogForm>
      <ExitWarningDialog />
    </Form>
  );
};
